// import socket from "@/plugins/socket";

// import Axios from "@/plugins/axios";

// export default {
//   data() {
//     return {
//       socket: {
//         state: false,
//         expire_at: null,
//         token: null,
//         reconnectTimeout: null,
//       },
//       connectionCheckInterval: null,
//       connectionCheckIntervalState: false,
//       lastDeviceUpdate: 0,
//       tokenFetchedAt: null,
//     };
//   },
//   computed: {
//     loggedIn() {
//       return this.$store.getters["user/valid"];
//     },
//   },
//   watch: {
//     loggedIn(valid) {
//       if (valid && !this.socket.state) {
//         this.connectSocket();
//       } else {
//         this.disconnectSocket();
//       }
//     },
//   },
//   mounted() {
//     this.socketListeners();
//     this.setConnectionCheckInterval();
//   },
//   methods: {
//     async connectSocket() {
//       await this.getSocketToken();
//       socket.auth = { token: this.socket.token };
//       if (this.socket.token) {
//         socket.connect();
//         this.createConnectivityIssues();
//         this.setReconnectSocket();
//       }
//     },
//     disconnectSocket() {
//       socket.disconnect();
//       this.socket.state = false;
//     },
//     setReconnectSocket() {
//       let timeout = +new Date(this.socket.expire_at) - +new Date();
//       timeout -= 300000; //5 minutes
//       this.socket.reconnectTimeout = setTimeout(() => {
//         this.disconnectSocket();
//         this.connectSocket();
//       }, timeout);
//     },
//     async getSocketToken() {
//       const timeToWait = 1000 * 60 * 2; // 2 minutes
//       const skipIf = +new Date() < this.tokenFetchedAt + timeToWait; // now is smaller than end skip time
//       if (!skipIf || this.loggedIn) {
//         await Axios.get("ws/get-token")
//           .then((res) => {
//             this.socket.expire_at = res.data.data.expire_at;
//             this.socket.token = res.data.data.token;
//           })
//           .catch((err) => {
//             console.log("error is: ", err);
//           })
//           .finally(() => {
//             this.tokenFetchedAt = +new Date();
//           });
//       }
//     },
//     socketListeners() {
//       socket.on("device", (data) => {
//         // console.log("data socket", data);
//         this.lastDeviceUpdate = +new Date();
//         // let device;
//         if (data.device) {
//           const device = this.$store.getters["devices/device"](
//             data.device.slug
//           );
//           for (const param in data.device) {
//             device[param] = data.device[param];
//           }
//           this.$store.dispatch("devices/setDevice", device);
//         }
//       });
//       socket.on("notification", (notification) => {
//         // console.log("New notification from socket: ", notification);
//         this.$store.dispatch("notifications/newUnread", notification);
//       });
//       socket.on("user", (user) => {
//         // console.log("New user from socket: ", user);
//         this.$store.dispatch("user/socketUser", user);
//       });
//       socket.on("advertisement", (ad) => {
//         const data = ad;
//         let newData = {
//           dispatch: {
//             advertisement: {},
//           },
//         };
//         switch (data.ad_type) {
//           case "system":
//             newData.dispatch.advertisement.title = data.title;
//             newData.dispatch.advertisement.message = data.body;
//             newData.dispatch.advertisement.slug = data.slug;
//             newData.dispatch.advertisement.type = data.advertisement_type;
//             newData.dispatch.advertisement.must_agree = data.must_agree;
//             newData.dispatch.advertisement.allow_disagree = data.disagree
//               ? data.disagree
//               : 0;
//             newData.watched_at = null;
//             newData.agreed = 0;
//             // this.systemNotificationsStore.ownNotifications.push(newData);
//             this.$store.dispatch("systemAdvertisements/newUnread", newData);
//             break;
//           case "promotion":
//             newData.dispatch.advertisement.title = data.title;
//             newData.dispatch.advertisement.message = data.body;
//             newData.dispatch.advertisement.slug = data.slug;
//             newData.dispatch.advertisement.must_agree = data.must_agree;
//             newData.dispatch.advertisement.allow_disagree = data.disagree
//               ? data.disagree
//               : 0;
//             newData.watched_at = null;
//             newData.agreed = 0;
//             // this.promotionNotificationsStore.ownNotifications.push(newData);
//             this.$store.dispatch("promotionAdvertisements/newUnread", newData);
//             break;
//           case "user":
//             newData.dispatch.advertisement.title = data.title;
//             newData.dispatch.advertisement.message = data.body;
//             newData.dispatch.advertisement.slug = data.slug;
//             newData.watched_at = null;
//             newData.agreed = 0;
//             // this.advertisementNotificationsStore.ownNotifications.push(newData);
//             this.$store.dispatch(
//               "notificationAdvertisements/newUnread",
//               newData
//             );
//             break;

//           default:
//             break;
//         }
//       });
//       socket.on("device-notification", (notification) => {
//         // console.log("New device notification from socket: ", notification);
//         if (notification.should_confirm) {
//           this.$store.dispatch(
//             "notifications/insertNotificationToConfirm",
//             notification
//           );
//         }
//       });
//     },
//     createConnectivityIssues() {
//       if (this.loggedIn) {
//         this.$nextTick(function () {
//           // window.addEventListener("blur", () => {
//           // console.log("leftpage");
//           // });
//           window.addEventListener("focus", () => {
//             const timeLost =
//               this.lastDeviceUpdate > 0 &&
//               +new Date() - this.lastDeviceUpdate > 180000;
//             if (!socket.connected || timeLost) {
//               this.$store.dispatch("devices/fetchDevices");
//               this.disconnectSocket();
//               this.connectSocket();
//             }
//           });
//         });
//       }
//     },
//     setConnectionCheckInterval() {
//       if (!this.connectionCheckIntervalState) {
//         this.connectionCheckIntervalState = true;
//         clearInterval(this.connectionCheckInterval);
//         this.connectionCheckInterval = setInterval(() => {
//           if (!socket.connected) this.connectSocket();
//         }, 10000);
//       }
//     },
//   },
// };

import socket from "@/plugins/socket";
import Axios from "@/plugins/axios";

export default {
  data() {
    return {
      socket: {
        state: false,
        expire_at: null,
        token: null,
        reconnectTimeout: null,
      },
      connectionCheckInterval: null,
      connectionCheckIntervalState: false,
      lastDeviceUpdate: 0,
      tokenFetchedAt: null,
      isConnecting: false, // מונע ניסיונות חיבור מקבילים
      focusListenerRegistered: false, // מונע ריבוי event listeners
    };
  },

  computed: {
    loggedIn() {
      return this.$store.getters["user/valid"];
    },
  },

  watch: {
    loggedIn(valid) {
      // התחברות: אם נהיה valid ויש לנו חיבור לא פעיל
      if (valid && !this.socket.state) {
        this.connectSocket();
      }
      // התנתקות: אם כבר לא מחובר למערכת והחיבור פעיל
      else if (!valid && this.socket.state) {
        this.disconnectSocket();
      }
    },
  },

  mounted() {
    this.socketListeners();
    this.setConnectionCheckInterval();
  },

  beforeDestroy() {
    // ניקוי interval
    if (this.connectionCheckInterval) {
      clearInterval(this.connectionCheckInterval);
      this.connectionCheckInterval = null;
      this.connectionCheckIntervalState = false;
    }

    // ניקוי reconnect timeout
    if (this.socket.reconnectTimeout) {
      clearTimeout(this.socket.reconnectTimeout);
      this.socket.reconnectTimeout = null;
    }

    // ניקוי focus listener
    if (this.focusListenerRegistered) {
      window.removeEventListener("focus", this.handleWindowFocus);
      this.focusListenerRegistered = false;
    }
  },

  methods: {
    logSocketEvent(eventName, payload, extra = {}) {
      console.groupCollapsed(`[socket:${eventName}] event received`);
      console.log("payload:", payload);
      console.log("extra:", extra);
      console.log("socket state:", {
        connected: socket.connected,
        id: socket.id,
        localState: this.socket.state,
        loggedIn: this.loggedIn,
      });
      console.trace(`[socket:${eventName}] trace`);
      console.groupEnd();
    },

    logSocketEventError(eventName, error, payload, extra = {}) {
      console.group(`[socket:${eventName}] handler failed`);
      console.error("error:", error);
      console.log("payload:", payload);
      console.log("extra:", extra);
      console.log("socket state:", {
        connected: socket.connected,
        id: socket.id,
        localState: this.socket.state,
        loggedIn: this.loggedIn,
      });
      console.trace(`[socket:${eventName}] failure trace`);
      console.groupEnd();
    },

    async connectSocket() {
      // לא מתחילים חיבור אם כבר באמצע ניסיון חיבור
      if (this.isConnecting || !this.loggedIn) return;

      this.isConnecting = true;

      try {
        await this.getSocketToken();

        if (!this.socket.token) {
          return;
        }

        socket.auth = { token: this.socket.token };

        // מחכים לחיבור / שגיאה כדי שה־isConnecting יישאר true בזמן ה-handshake
        await new Promise((resolve, reject) => {
          const onConnect = () => {
            socket.off("connect_error", onError);
            resolve();
          };
          const onError = (err) => {
            socket.off("connect", onConnect);
            reject(err);
          };

          socket.once("connect", onConnect);
          socket.once("connect_error", onError);

          socket.connect();
        });

        this.socket.state = true;
        this.createConnectivityIssues();
        this.setReconnectSocket();
      } catch (err) {
        console.error("connectSocket error:", err);
      } finally {
        this.isConnecting = false;
      }
    },

    async disconnectSocket() {
      if (this.socket.reconnectTimeout) {
        clearTimeout(this.socket.reconnectTimeout);
        this.socket.reconnectTimeout = null;
      }

      try {
        socket.disconnect();
      } finally {
        this.socket.state = false;
      }
    },

    setReconnectSocket() {
      if (!this.socket.expire_at) return;

      let timeout = +new Date(this.socket.expire_at) - +new Date();
      timeout -= 300000; // 5 דקות לפני פקיעת הטוקן

      if (timeout <= 0) {
        timeout = 0;
      }

      if (this.socket.reconnectTimeout) {
        clearTimeout(this.socket.reconnectTimeout);
      }

      this.socket.reconnectTimeout = setTimeout(() => {
        this.disconnectSocket();
        this.connectSocket();
      }, timeout);
    },

    async getSocketToken() {
      const timeToWait = 1000 * 60 * 2; // 2 דקות

      let skipIf = false;
      if (this.tokenFetchedAt) {
        skipIf = +new Date() < this.tokenFetchedAt + timeToWait;
      }

      // רק אם מחובר למערכת, ורק אם לא אמור לדלג
      if (this.loggedIn && !skipIf) {
        try {
          const res = await Axios.get("ws/get-token", { timeout: 10000 });
          this.socket.expire_at = res.data.data.expire_at;
          this.socket.token = res.data.data.token;
        } catch (err) {
          console.log("getSocketToken error:", err);
        } finally {
          this.tokenFetchedAt = +new Date();
        }
      }
    },

    socketListeners() {
      socket.on("device", (data) => {
        const eventName = "device";

        try {
          this.lastDeviceUpdate = +new Date();
          // this.logSocketEvent(eventName, data, {
          //   hasDevicePayload: !!(data && data.device),
          //   deviceSlug: data && data.device ? data.device.slug : undefined,
          //   devicePayloadKeys:
          //     data && data.device ? Object.keys(data.device) : [],
          // });

          if (data && data.device) {
            const device = this.$store.getters["devices/device"](
              data.device.slug
            );

            if (!device) {
              this.logSocketEventError(
                eventName,
                new Error(
                  "Device payload received but no matching device exists in store"
                ),
                data,
                {
                  deviceSlug: data.device.slug,
                  devicePayloadKeys: Object.keys(data.device),
                  getter: 'this.$store.getters["devices/device"]',
                }
              );
              return;
            }

            for (const param in data.device) {
              device[param] = data.device[param];
            }
            this.$store.dispatch("devices/setDevice", device);
          }
        } catch (error) {
          this.logSocketEventError(eventName, error, data, {
            lastDeviceUpdate: this.lastDeviceUpdate,
          });
          throw error;
        }
      });

      socket.on("notification", (notification) => {
        const eventName = "notification";

        try {
          this.logSocketEvent(eventName, notification);
          this.$store.dispatch("notifications/newUnread", notification);
        } catch (error) {
          this.logSocketEventError(eventName, error, notification);
          throw error;
        }
      });

      socket.on("user", (user) => {
        const eventName = "user";

        try {
          this.logSocketEvent(eventName, user);
          this.$store.dispatch("user/socketUser", user);
        } catch (error) {
          this.logSocketEventError(eventName, error, user);
          throw error;
        }
      });

      socket.on("advertisement", (ad) => {
        const eventName = "advertisement";

        try {
          this.logSocketEvent(eventName, ad, {
            adType: ad && ad.ad_type,
            adSlug: ad && ad.slug,
          });

          const data = ad;
          let newData = {
            dispatch: {
              advertisement: {},
            },
          };

          switch (data.ad_type) {
            case "system":
              newData.dispatch.advertisement.title = data.title;
              newData.dispatch.advertisement.message = data.body;
              newData.dispatch.advertisement.slug = data.slug;
              newData.dispatch.advertisement.type = data.advertisement_type;
              newData.dispatch.advertisement.must_agree = data.must_agree;
              newData.dispatch.advertisement.allow_disagree = data.disagree
                ? data.disagree
                : 0;
              newData.watched_at = null;
              newData.agreed = 0;
              this.$store.dispatch("systemAdvertisements/newUnread", newData);
              break;

            case "promotion":
              newData.dispatch.advertisement.title = data.title;
              newData.dispatch.advertisement.message = data.body;
              newData.dispatch.advertisement.slug = data.slug;
              newData.dispatch.advertisement.must_agree = data.must_agree;
              newData.dispatch.advertisement.allow_disagree = data.disagree
                ? data.disagree
                : 0;
              newData.watched_at = null;
              newData.agreed = 0;
              this.$store.dispatch(
                "promotionAdvertisements/newUnread",
                newData
              );
              break;

            case "user":
              newData.dispatch.advertisement.title = data.title;
              newData.dispatch.advertisement.message = data.body;
              newData.dispatch.advertisement.slug = data.slug;
              newData.watched_at = null;
              newData.agreed = 0;
              this.$store.dispatch(
                "notificationAdvertisements/newUnread",
                newData
              );
              break;

            default:
              console.warn(`[socket:${eventName}] unknown ad_type`, {
                adType: data && data.ad_type,
                payload: data,
              });
              break;
          }
        } catch (error) {
          this.logSocketEventError(eventName, error, ad, {
            adType: ad && ad.ad_type,
            adSlug: ad && ad.slug,
          });
          throw error;
        }
      });

      socket.on("device-notification", (notification) => {
        const eventName = "device-notification";

        try {
          this.logSocketEvent(eventName, notification, {
            shouldConfirm: notification && notification.should_confirm,
          });

          if (notification && notification.should_confirm) {
            this.$store.dispatch(
              "notifications/insertNotificationToConfirm",
              notification
            );
          }
        } catch (error) {
          this.logSocketEventError(eventName, error, notification, {
            shouldConfirm: notification && notification.should_confirm,
          });
          throw error;
        }
      });
    },

    createConnectivityIssues() {
      if (this.loggedIn && !this.focusListenerRegistered) {
        this.focusListenerRegistered = true;
        window.addEventListener("focus", this.handleWindowFocus);
      }
    },

    async handleWindowFocus() {
      const timeLost =
        this.lastDeviceUpdate > 0 &&
        +new Date() - this.lastDeviceUpdate > 180000;

      if ((!socket.connected || timeLost) && this.loggedIn) {
        this.$store.dispatch("devices/fetchDevices");
        const canViewAiInsights = !!(
          this.$userPermissions &&
          this.$userPermissions.permitted("dashboard.ai-insights")
        );

        this.$store.dispatch("dashboard/fetchAllInsights", {
          background: true,
          force: true,
          includeAi: canViewAiInsights,
        });
        await this.disconnectSocket();
        await this.connectSocket();
      }
    },

    setConnectionCheckInterval() {
      if (!this.connectionCheckIntervalState) {
        this.connectionCheckIntervalState = true;
        clearInterval(this.connectionCheckInterval);

        this.connectionCheckInterval = setInterval(() => {
          if (!socket.connected && this.loggedIn) {
            this.connectSocket();
          }
        }, 10000);
      }
    },
  },
};
